"use client";

import { isbot } from "isbot";
import { STORAGE_KEYS } from "~/types/Storage";
import { getStorageItem } from "~/lib/storage/Storage";
import { FX_EVENT_NAMES, fxItemProperties, type FxEventPayload } from "~/lib/optimizely/fxEvents";

export const FX_TRACK_ENDPOINT = "/api/optimizely/track";

const isTrackable = () =>
    typeof window !== "undefined" && !isbot(navigator.userAgent) && !getStorageItem(STORAGE_KEYS.IS_ADMIN_LOGIN);

// sendBeacon first: purchase and quiz_completed fire as the page navigates away.
function sendFx(payload: FxEventPayload | { flag_key: string }): void {
    if (!isTrackable()) return;

    const body = JSON.stringify(payload);

    try {
        if (navigator.sendBeacon?.(FX_TRACK_ENDPOINT, new Blob([body], { type: "application/json" }))) return;
    } catch {
        // Falls through to fetch.
    }

    void fetch(FX_TRACK_ENDPOINT, {
        method: "POST",
        headers: { "content-type": "application/json" },
        body,
        keepalive: true,
    }).catch(() => undefined);
}

export function trackFxEvent(payload: FxEventPayload): void {
    if (payload.event_name) sendFx(payload);
}

export function trackFxImpression(flagKey: string): void {
    sendFx({ flag_key: flagKey });
}

export function trackFxPurchase(value: number, items?: Parameters<typeof fxItemProperties>[0]): void {
    trackFxEvent({
        event_name: FX_EVENT_NAMES.PURCHASE,
        value,
        revenue: Math.round(value * 100),
        properties: fxItemProperties(items),
    });
}
